import React from 'react';
import { Table } from '@zillow/constellation';

export const TaskHeaders = () => {
  return (
    <Table.Row>
      <Table.HeaderCell>&nbsp;</Table.HeaderCell>
      <Table.SortableHeaderCell id={'taskName'}>Task</Table.SortableHeaderCell>
      <Table.SortableHeaderCell id={'role'}>Role</Table.SortableHeaderCell>
      <Table.SortableHeaderCell id={'assignedTo'}>Assigned To</Table.SortableHeaderCell>
      <Table.SortableHeaderCell id={'dueDate'}>Due</Table.SortableHeaderCell>
      <Table.HeaderCell>&nbsp;</Table.HeaderCell>
    </Table.Row>
  );
};
